export const UserChannel = userId =>
	`App.User.${userId}`

export const UserChatsChannel = userId =>
	`App.User.${userId}.Chats`

export const ChatChannel = (chatId) =>
	`App.Chat.${chatId}`